export { ScreenReadyMarker, type ScreenReadyMarkerProps } from "#screen-ready-marker";
